
import wixWindow from 'wix-window';
import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixSite from 'wix-site';
import wixSeo from 'wix-seo';
import wixUsers from 'wix-users';
import wixAnimations from 'wix-animations';

let lastWindowWidth = 0;

const options = {
  day: "numeric",
  month: "short",
  year: "numeric"
};

$w.onReady(function () {
  $w("#pageName").text = "Welcome to FISITA"
  $w("#crumb1").label = "Home";
  $w("#crumb1").link = "/home";
  // $w("#crumb2").label = 
  // $w("#crumb2").link = 
  // $w("#crumb3").label = 
  // $w("#crumb3").link = 
  // $w("#crumb4").label = 
  // $w("#crumb4").link = 
  
  $w("#crumb1").expand();
  $w("#crumb2").collapse();
  $w("#crumb3").collapse();
  $w("#crumb4").collapse();

  setInterval(responsifyPage, 100);

  isUserLoggedIn();
  // store repeater

  
  $w("#corporatesRepeater").onItemReady(($item, itemData, index) => {
    $item("#corporatesBtn").label = itemData.title;
    $item("#corporatesBtn").link = itemData['link-companies-title-7'];
    $item("#corporatesLogo").src = itemData.logo;
    $item("#corporatesLogo").alt = itemData.title;
  });

  wixData.query("Companies")
    .contains("memberType", 'Corporate')
    .ascending("slug")
    .limit(100)
    .find()
    .then((results) => {
      if (results.totalCount > 0) {
        $w("#corporatesRepeater").data = results.items;
      } 
    })
    .catch((error) => {
      console.log("Error:", error.message);
    });

  let today = new Date();
	console.log(today);
	today.setHours(0);
	today.setMinutes(0);
	today.setSeconds(0);
  
  $w("#eventRepeater").onItemReady(($item, itemData, index) => {
    let eventStartDate = itemData.startDate.toLocaleDateString("en-GB", options);
   	let eventEndDate = itemData.endDate.toLocaleDateString("en-GB", options);

    $item("#eventBtn").label = itemData.title;
    $item("#eventBtn").link = itemData['link-diary-1-title'];
    $item("#eventFindOutMoreBtn").link = itemData['link-diary-1-title'];
    
    $item("#eventTagline").text = itemData.tagline;
    $item("#eventImage").src = itemData.coverImage;
    $item("#eventImage").link = itemData['link-diary-1-title'];
    $item("#eventImage").alt = itemData.title;

   
      if (eventEndDate === undefined) {
        $item('#eventDate').text = eventStartDate+", "+itemData.location;
      } else {
        if (eventStartDate === eventEndDate) {
          $item('#eventDate').text = eventStartDate+", "+itemData.location;
        } else {
          $item('#eventDate').text = eventStartDate+" to "+eventEndDate+", "+itemData.location;
        }
      }
      if (eventStartDate === undefined && eventEndDate === undefined) {
        $item('#eventDate').text = itemData.location;
      }
      if (eventStartDate === undefined && eventEndDate === undefined && itemData.location === undefined) {
        $item('#eventDate').collapse();
      }
      if (itemData.title === 'FISITA Intelligent Safety Conference 2022') {
      $item('#eventDate').text = "2022";
      }
    

  });

  wixData.query("Diary").limit(1).gt("endDate",today).eq('fisitaEvent',true).ascending("startDate").find()
  .then((results) => {
    if (results.totalCount > 0) {
      $w("#eventRepeater").data = results.items;
    } 
  })
  .catch((error) => {
    console.log("Error:", error.message);
  });

  $w("#blogWrapper").onItemReady(($item, itemData, index) => {
    $item("#blogBtn").label = itemData.title;
    $item("#blogBtn").link = itemData.postPageUrl;
    $item("#blogReadNowBtn").link = itemData.postPageUrl;
    $item("#blogDate").text = itemData.publishedDate.toLocaleDateString("en-GB", options)
    $item("#blogExcerpt").text = itemData.excerpt;
    $item("#blogImg").src = itemData.coverImage;
    $item("#blogImg").link = itemData.postPageUrl;
    $item("#blogImg").alt = itemData.title;
  });

  wixData.query("Blog/Posts")
    .descending("publishedDate")
    .limit(1)
    .find()
    .then((results) => {
      if (results.totalCount > 0) {
        $w("#blogWrapper").data = results.items;
      } 
    })
    .catch((error) => {
      console.log("Error:", error.message);
  });

  $w("#moreBlogsRepeater").onItemReady(($item, itemData, index) => {
    $item("#moreBlogsItemBtn").label = itemData.title;
    $item("#moreBlogsItemBtn").link = itemData.postPageUrl;
    $item("#moreBlogsItemReadNowBtn").link = itemData.postPageUrl;
    $item("#moreBlogsItemDate").text = itemData.publishedDate.toLocaleDateString("en-GB", options)
    $item("#moreBlogsItemExcerpt").text = itemData.excerpt;
    $item("#moreBlogsItemImage").src = itemData.coverImage;
    $item("#moreBlogsItemImage").link = itemData.postPageUrl;
    $item("#moreBlogsItemImage").alt = itemData.title;
  });

  wixData.query("Blog/Posts")
    .descending("publishedDate")
    .limit(4)
    .find()
    .then((results) => {
      if (results.totalCount > 0) {
        $w("#moreBlogsRepeater").data = results.items;
      } 
    })
    .catch((error) => {
      console.log("Error:", error.message);
    });

  $w("#moreEventsRepeater").onItemReady(($item, itemData, index) => {
    let eventStartDate = itemData.startDate.toLocaleDateString("en-GB", options);
   	let eventEndDate = itemData.endDate.toLocaleDateString("en-GB", options);

    $item("#moreEventsItemBtn").label = itemData.title;
    $item("#moreEventsItemBtn").link = itemData['link-diary-1-title'];
    $item("#moreBlogsItemFindOutMoreBtn").link = itemData['link-diary-1-title'];
    $item("#moreEventsItemTagline").text = itemData.tagline;
    
    $item("#moreEventsItemImage").link = itemData['link-diary-1-title'];
    $item("#moreEventsItemImage").alt = itemData.title;

    $item("#moreEventsItemImage").src = itemData.brandedHeaderImage;
    $item("#moreEventsVector").src = itemData.svgCodeWhite;
    $item("#moreEventsVector").link = itemData['link-diary-1-title'];
    $item("#moreEventsItemColouredBG").style.backgroundColor = itemData.brandedHeaderColour;
    $item("#moreEventsItemColouredBG").onClick( (event, $w) => {
      wixLocation.to(itemData['link-diary-1-title']);
    });

    if (itemData.title === 'EuroBrake 2022') {
			$item('#moreEventsItemDate').text = "May 2022, "+itemData.location;
		} else {
			if (eventEndDate === undefined) {
				$item('#moreEventsItemDate').text = eventStartDate+", "+itemData.location;
			} else {
        if (eventStartDate === eventEndDate) {
        	$item('#moreEventsItemDate').text = eventStartDate+", "+itemData.location;
        } else {
        	$item('#moreEventsItemDate').text = eventStartDate+" to "+eventEndDate+", "+itemData.location;
        }
			}
			if (eventStartDate === undefined && eventEndDate === undefined) {
				$item('#moreEventsItemDate').text = itemData.location;
			}
			if (eventStartDate === undefined && eventEndDate === undefined && itemData.location === undefined) {
				$item('#moreEventsItemDate').collapse();
			}
      if (itemData.title === 'FISITA Intelligent Safety Conference 2022') {
      $item('#moreEventsItemDate').text = "2022";
      }
    }
  });
	
  wixData.query("Diary").limit(4).gt("endDate",today).eq('fisitaEvent',true).ascending("startDate").find()
  .then((results) => {
    if (results.totalCount > 0) {
      $w("#moreEventsRepeater").data = results.items;
    } 
  })
  .catch((error) => {
    console.log("Error:", error.message);
  });
});

function responsifyPage() {
  wixWindow.getBoundingRect()
  .then(windowSizeInfo => {
    // check for resize
    if (lastWindowWidth !== windowSizeInfo.window.width) {
      // get size
      lastWindowWidth = windowSizeInfo.window.width;
      // hide or show elements based on size
      if (lastWindowWidth > 1001) {
        $w("#accountMenuWrapper").expand();
        $w("#mobileMenu").collapse();
        $w("#crumbWrapper").expand();
        $w("#desktopMenuWrapper").expand();
        // $w("#eventDescription").expand();
        // $w("#blogExcerpt").expand();
      }
      if (lastWindowWidth < 1001) {
        $w("#accountMenuWrapper").collapse();
        $w("#mobileMenu").expand();
        $w("#crumbWrapper").collapse();
        $w("#desktopMenuWrapper").collapse();
        // $w("#eventDescription").collapse();
        // $w("#blogExcerpt").collapse();
      }
      if (lastWindowWidth < 751) {
        $w("#blogExcerpt").expand();
      }
    }
  });
}

async function isUserLoggedIn() {
	let user = wixUsers.currentUser;
	let isLoggedIn = user.loggedIn;
	if (isLoggedIn) {
		$w('#iccIntroLoggedIn').expand();
		$w('#iccIntroLoggedOut').collapse();
	}
}

export function joinTrigger_click(event) {
	if ($w('#joinContent').collapsed){
    joinContentOpen();
  } else {
    joinContentClose();
  }
}

export function communityTrigger_click(event) {
	if ($w('#communityContent').collapsed){
    communityContentOpen();
  } else {
    communityContentClose();
  }
}

export function libraryTrigger_click(event) {
	if ($w('#libraryContent').collapsed){
    libraryContentOpen();
  } else {
    libraryContentClose();
  }
}

export function newsletterTrigger_click(event) {
	if ($w('#newsletterContent').collapsed){
    newsletterContentOpen();
  } else {
    newsletterContentClose();
  }
}



async function joinContentOpen() {
  $w('#joinContent').expand();
  let timeline = wixAnimations.timeline();
  const plus = $w("#joinPlusWrapper");
  
  timeline.add(plus, {
    "rotate": 65,
    "duration": 300
  });
  timeline.add(plus, {
    "rotate": 45,
    "duration": 200
  });
  timeline.play();


  if (!$w('#communityContent').collapsed){communityContentClose();}
  if (!$w('#libraryContent').collapsed){libraryContentClose();}
  if (!$w('#newsletterContent').collapsed){newsletterContentClose();}
}
async function joinContentClose() {
  $w('#joinContent').collapse();
  let timeline = wixAnimations.timeline();
  const plus = $w("#joinPlusWrapper");
  
  timeline.add(plus, {
    "rotate": -20,
    "duration": 300
  });
  timeline.add(plus, {
  "rotate": 0,
  "duration": 200
  });
  timeline.play();
}

async function communityContentOpen() {
  $w('#communityContent').expand();
  let timeline = wixAnimations.timeline();
  const plus = $w("#communityPlusWrapper");
  
  timeline.add(plus, {
    "rotate": 65,
    "duration": 300
  });
  timeline.add(plus, {
    "rotate": 45,
    "duration": 200
  });
  timeline.play();

  
  if (!$w('#joinContent').collapsed){joinContentClose();}
  if (!$w('#libraryContent').collapsed){libraryContentClose();}
  if (!$w('#newsletterContent').collapsed){newsletterContentClose();}
}
async function communityContentClose() {
  $w('#communityContent').collapse();
  let timeline = wixAnimations.timeline();
  const plus = $w("#communityPlusWrapper");
  
  timeline.add(plus, {
    "rotate": -20,
    "duration": 300
  });
  timeline.add(plus, {
  "rotate": 0,
  "duration": 200
  });
  timeline.play();
}

async function libraryContentOpen() {
  $w('#libraryContent').expand();
  let timeline = wixAnimations.timeline();
  const plus = $w("#libraryPlusWrapper");
  
  timeline.add(plus, {
    "rotate": 65,
    "duration": 300
  });
  timeline.add(plus, {
    "rotate": 45,
    "duration": 200
  });
  timeline.play();

  
  if (!$w('#joinContent').collapsed){joinContentClose();}
  if (!$w('#communityContent').collapsed){communityContentClose();}
  if (!$w('#newsletterContent').collapsed){newsletterContentClose();}
}
async function libraryContentClose() {
  $w('#libraryContent').collapse();
  let timeline = wixAnimations.timeline();
  const plus = $w("#libraryPlusWrapper");
  
  timeline.add(plus, {
    "rotate": -20,
    "duration": 300
  });
  timeline.add(plus, {
  "rotate": 0,
  "duration": 200
  });
  timeline.play();
}

async function newsletterContentOpen() {
  $w('#newsletterContent').expand();
  let timeline = wixAnimations.timeline();
  const plus = $w("#newsletterPlusWrapper");
  
  timeline.add(plus, {
    "rotate": 65,
    "duration": 300
  });
  timeline.add(plus, {
    "rotate": 45,
    "duration": 200
  });
  timeline.play();

  
  if (!$w('#joinContent').collapsed){joinContentClose();}
  if (!$w('#communityContent').collapsed){communityContentClose();}
  if (!$w('#libraryContent').collapsed){libraryContentClose();}
}
async function newsletterContentClose() {
  $w('#newsletterContent').collapse();
  let timeline = wixAnimations.timeline();
  const plus = $w("#newsletterPlusWrapper");
  
  timeline.add(plus, {
    "rotate": -20,
    "duration": 300
  });
  timeline.add(plus, {
  "rotate": 0,
  "duration": 200
  });
  timeline.play();
}
